var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FetchRequest } from '@portkey/request';
export function parseAppleIdentityToken(identityToken) {
    if (!identityToken)
        return;
    const parts = identityToken.split('.');
    const payload = JSON.parse(Buffer.from(parts[1], 'base64').toString());
    const expirationTime = new Date(payload.exp * 1000);
    const isExpired = expirationTime < new Date();
    const userId = payload.sub;
    const email = payload.email;
    const isPrivate = typeof payload.is_private_email === 'string'
        ? payload.is_private_email === 'true'
        : payload.is_private_email || !payload.email;
    return { isExpired, userId, email, expirationTime, isPrivate };
}
const TmpUserInfo = {};
export function getGoogleUserInfo(accessToken = '') {
    return __awaiter(this, void 0, void 0, function* () {
        const customFetch = new FetchRequest({});
        if (!TmpUserInfo[accessToken])
            TmpUserInfo[accessToken] = yield customFetch.send({
                url: 'https://www.googleapis.com/userinfo/v2/me',
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });
        return Object.assign(Object.assign({}, TmpUserInfo[accessToken]), { firstName: TmpUserInfo[accessToken].given_name, lastName: TmpUserInfo[accessToken].family_name });
    });
}
export function parseTelegramToken(token) {
    if (!token)
        return;
    const parts = token.split('.');
    const payload = JSON.parse(Buffer.from(parts[1], 'base64').toString());
    const expirationTime = payload.exp * 1000;
    const isExpired = new Date(expirationTime) < new Date();
    const userId = payload.userId;
    const firstName = payload.firstName;
    const picture = payload.protoUrl;
    const lastName = payload.lastName;
    return { isExpired, userId, expirationTime, isPrivate: true, firstName, picture, lastName, id: userId };
}
const fbUserInfo = {};
export function parseFacebookToken(tokenStr) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        if (!tokenStr)
            return;
        try {
            const { userId, token: accessToken, expiresTime } = JSON.parse(tokenStr);
            const expirationTime = Number(expiresTime) * 1000;
            const isExpired = new Date(expirationTime) < new Date();
            const customFetch = new FetchRequest({});
            if (!fbUserInfo[accessToken]) {
                const result = yield customFetch.send({
                    url: `https://graph.facebook.com/${userId}?fields=id,name,email,picture&access_token=${accessToken}`,
                    method: 'GET',
                });
                const [firstName, lastName] = result === null || result === void 0 ? void 0 : result.name.split(' ');
                fbUserInfo[accessToken] = {
                    userId,
                    id: userId,
                    name: result.name,
                    isExpired,
                    expirationTime,
                    isPrivate: true,
                    firstName,
                    lastName,
                    picture: (_b = (_a = result === null || result === void 0 ? void 0 : result.picture) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.url,
                    accessToken: accessToken,
                };
            }
            return fbUserInfo[accessToken];
        }
        catch (error) {
            return;
        }
    });
}
const XUserInfo = {};
export function getTwitterInfoByToken(tokenStr) {
    try {
        return JSON.parse(tokenStr);
    }
    catch (error) {
        return {};
    }
}
export function parseTwitterToken(tokenStr) {
    if (!tokenStr)
        return;
    console.log(tokenStr, 'tokenStr=');
    try {
        const info = getTwitterInfoByToken(tokenStr);
        console.log(info, 'info===');
        const { id = '', name = '', username = '', token = '' } = info;
        const [firstName, lastName] = name.split(' ');
        if (!token)
            return;
        let expirationTime = Date.now() + 60 * 60 * 1000;
        if (XUserInfo[tokenStr])
            expirationTime = XUserInfo[tokenStr].expirationTime;
        const isExpired = new Date(expirationTime) < new Date();
        return {
            isExpired,
            userId: id,
            id,
            expirationTime,
            firstName: firstName,
            lastName: lastName,
            picture: undefined,
            email: undefined,
            isPrivate: true,
            name: name,
            accessToken: token,
            username,
        };
    }
    catch (error) {
        return;
    }
}
